import { render, staticRenderFns } from "./orderFormByChannel2.vue?vue&type=template&id=3dde43ce"
import script from "./orderFormByChannel2.vue?vue&type=script&lang=js"
export * from "./orderFormByChannel2.vue?vue&type=script&lang=js"
import style0 from "./orderFormByChannel2.vue?vue&type=style&index=0&id=3dde43ce&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports